import { ReactNode } from 'react';
import { BadgeSkin } from '../Badge';

export type BadgeSelectItemSizes = 'small' | 'medium';

export interface BadgeSelectItemProps {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  id?: string | number;
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  /** Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */
  className?: string;
  /** The text to be rendered within the badge. */
  text: ReactNode;
  /** The secondary text to be rendered within the badge. */
  subtitle?: string;
  /** The badge's skin. See the <Badge/> story for the full list of available skins. */
  skin: BadgeSkin;
  /** Should the text and subtitle get ellipsis with tooltip, or should it get broken into lines when it reaches the end of its container */
  ellipsis?: boolean;
  /** If true, the item is selected */
  selected?: boolean;
  /** If true, the item is highlighted */
  highlighted?: boolean;
  /** If true, the item is disabled */
  disabled?: boolean;
  /** Any suffix */
  suffix?: ReactNode;
  /** Changing text size */
  size?: BadgeSelectItemSizes;
}

export type BadgeSelectItemBuilderProps = Omit<
  BadgeSelectItemProps,
  'selected' | 'highlighted'
> & {
  id: string | number;
};
